import React from 'react';

const DetailsCard = ({ history }) => {
  const { purpose, datetime, sohanPaid, amount } = history;
  return (
    <div className='card'>
      <p className='person'>{sohanPaid > 0 ? 'Sohan' : 'Rakib'}</p>
      <p className='amount'>{amount}</p>
      <div className='meta'>
        <p className='purpose'>{purpose}</p>
        <p className='date'>{datetime}</p>
      </div>
    </div>
  );
};

export default DetailsCard;
